var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"localP"},[_c('div',{staticClass:"header"},[_c('p-header')],1),_c('div',{staticClass:"container"},[_c('div',{staticClass:"aside"},[_c('el-menu',{attrs:{"background-color":"#F5F6FA","active-text-color":"#17B6A1","router":"","unique-opened":"","default-active":_vm.defaultActiveIndex},on:{"select":_vm.menuActive}},[_c('m-aside',{attrs:{"arrlist":_vm.routerlist,"msgnum":_vm.pendingRevie}})],1)],1),_c('div',{staticClass:"main"},[_c('div',{staticClass:"main_container_box"},[(_vm.refresh)?_c('keep-alive',{attrs:{"exclude":[
            'epinfomsg',
            'eplist',
            'southcargo',
            'cargoinfo',
            'planlistParticulars',
            'infomsg',
            'addcarlistinfo',
            'newaddparticulars',
            'particulars',
            'newaddcheck2',
            'addnoticelist',
            'mapCar',
            'homemapdetail',
            'guijihuifang'
          ]}},[_c('router-view')],1):_vm._e(),(!_vm.refresh)?_c('router-view'):_vm._e()],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }